import { render, staticRenderFns } from "./交易数据_获嘉.vue?vue&type=template&id=35988421&scoped=true"
import script from "./交易数据_获嘉.vue?vue&type=script&lang=js"
export * from "./交易数据_获嘉.vue?vue&type=script&lang=js"
import style0 from "./交易数据_获嘉.vue?vue&type=style&index=0&id=35988421&prod&lang=css"
import style1 from "./交易数据_获嘉.vue?vue&type=style&index=1&id=35988421&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35988421",
  null
  
)

export default component.exports